module.exports = __webpack_public_path__ + "img/logo6.51654a53.png";